<template>
  <div class="tab-content"
    v-show="isActive">
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false
    }
  },

  props: {
    name: { required: true },
    selected: { default: false }
  },

  computed: {
    href() {
      return '#' + this.name.toLowerCase().replace(/ /g, '-');
    }
  },

  mounted() {
    this.isActive = this.selected
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/Tab.vue